/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CandidateEntity } from './candidate-entity';
import { UserEntity } from './user-entity';
export class UsersSavedCandidateEntity extends Entity {
  candidate: CandidateEntity | null = null;
  candidateId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  updatedAt: string | null = null;
  user: UserEntity | null = null;
  userId: string | null = null;
  static override key = 'UsersSavedCandidate';
  static override get schema() {
    return {
      candidate: CandidateEntity,
      user: UserEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'UsersSavedCandidate' in input
    ) {
      const { UsersSavedCandidate: wrapped, ...rest } = input as {
        UsersSavedCandidate: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}